import * as React from 'react';
export const SuperBalancedPortfolio = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 70 76" fill="none" {...props}>
    <path
      d="M18.738.79C13.297-.734 7.655 2.44 6.132 7.882c-1.524 5.442 1.65 11.083 7.092 12.607 5.442 1.523 11.083-1.65 12.607-7.093C27.355 7.955 24.18 2.313 18.738.79zm-.925 8.697a3.04 3.04 0 01-2.104-3.745 3.04 3.04 0 112.104 3.746zM38.923 33.742c-11.51 0-20.833 9.324-20.833 20.833 0 11.51 9.323 20.833 20.833 20.833 11.51 0 20.833-9.324 20.833-20.833 0-11.51-9.324-20.833-20.833-20.833zm4.798 21.921a6.383 6.383 0 01-6.385-6.385 6.383 6.383 0 016.385-6.385 6.383 6.383 0 016.385 6.385 6.383 6.383 0 01-6.385 6.385z"
      fill="#600CE8"
    />
    <path
      d="M65.601 33.852L6.511 17.298a3.918 3.918 0 00-2.114 7.546l59.09 16.554a3.918 3.918 0 002.114-7.546z"
      fill="#600CE8"
    />
  </svg>
);
